module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ke-d625828986385991f7b18d07bc5c9960.svg";